import { useRef, useState } from 'react';
import { Typography } from 'darrius';

import styles from './CheckboxField.module.scss';

interface ICheckboxFieldProps {
  title: string;
  message: string;
  subCategoryIds: number[];
  // eslint-disable-next-line no-unused-vars
  handleInputClick?: (checkboxValue: string) => void;
}

export const CheckboxField = ({
  title,
  message,
  subCategoryIds,
  handleInputClick,
}: ICheckboxFieldProps) => {
  const [checked, setChecked] = useState(false);
  const inputRef = useRef(null);

  function handleClickCard() {
    setChecked(!checked);
    handleInputClick(inputRef.current.value as string);
  }

  return (
    <button
      type="button"
      className={`checkbox-field ${styles['checkbox-field']} `}
      onClick={handleClickCard}
    >
      <div className={styles.categories}>
        <Typography.Subtitle size="xl" className={styles.title}>
          {title}
        </Typography.Subtitle>
        <Typography.Text>{message}</Typography.Text>
      </div>
      <input
        type="checkbox"
        value={String(subCategoryIds)}
        ref={inputRef}
        checked={checked}
        tabIndex={-1}
        readOnly
      />
    </button>
  );
};
